import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import logo from '../../assets/logo.png';
import './Preloader.css';

const Preloader = ({ onComplete }) => {
  const containerRef = useRef(null);
  const logoRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    // We create a timeline for the exit animation
    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        if (onComplete) onComplete();
      }
    });

    // The luxury shutter/slide-up exit animation
    tl.to(logoRef.current, {
      scale: 1.3,
      opacity: 0,
      duration: 0.6,
      ease: "power2.in"
    })
    .to(textRef.current, {
      opacity: 0,
      y: -20,
      duration: 0.5,
      ease: "power2.in"
    }, "-=0.4")
    .to(containerRef.current, {
      yPercent: -100, // Slide up like a premium curtain
      duration: 1.2,
      ease: "expo.inOut"
    }, "-=0.1");

    // Start the exit animation after a short minimum delay to let users see the branding
    const timer = setTimeout(() => {
      // If document is fully loaded, animate out. Otherwise wait for load event.
      if (document.readyState === 'complete') {
        tl.play();
      } else {
        const handleLoad = () => tl.play();
        window.addEventListener('load', handleLoad);
        return () => window.removeEventListener('load', handleLoad);
      }
    }, 1800); // 1.8 seconds minimum display time

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="luxury-preloader" ref={containerRef}>
      <div className="preloader-content">
        <div className="preloader-logo-comp" ref={logoRef}>
          <div className="preloader-logo-ring"></div>
          <div className="preloader-logo-bottle">
            <img src={logo} alt="ESCENTRUM" className="preloader-logo-img" />
          </div>
        </div>
        <div className="preloader-text-wrapper">
          <h2 className="preloader-text" ref={textRef}>ESCENTRUM</h2>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
